<template>
  <section>
    <Modal
      v-model:show="is_open"
      class="sfa-modal"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          {{ $t('profile.secondFactorEnableForm.title') }}
        </h5>
      </template>
      
      <div>
        <div>
          <div class="sfa__block-icons pb-8 mb-10">
            <div class="tip mb-14">
              1. {{ $t('profile.secondFactorEnableForm.step1') }}
            </div>
            <div class="row img-wrap mr-0">
              <img
                :src="googleOtpImg"
                class="col-4 p-0"
              >
              <a
                href="https://apps.apple.com/ru/app/google-authenticator/id388497605"
                target="_blank"
                class="col-4 p-0"
              >
                <img
                  :src="appleOtpImg"
                  class="second-img"
                >
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                target="_blank"
                class="col-4 p-0"
              >
                <img :src="androidOtpImg">
              </a>
            </div>
          </div>
        </div>
        <div class="!tw-flex qr_wrap">
          <div class="qr-box !tw-w-1/2 mb-10">
            <img
              :src="data.url"
              alt="QR"
              class=""
            >
          </div>
          <div class="sfa__block-input !tw-w-1/2 mt-8">
            <div>
              <div class="tip mb-16">
                2. {{ $t('profile.secondFactorEnableForm.step2') }}
              </div>
              <TfaCodeInput
                :key="is_open"
                v-model="token"
                :field-width="32"
                :field-height="32"
                auto-focus
                @change="errors_ = {}"
                @complete="check2FACode"
              />
              <div
                v-if="errors_.token"
                class="login__error-title mb-8 mt-8"
              >
                {{ errors_.token[0].message }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <Modal
      v-model:show="show_codes"
      class="modal-password"
      @close="show_codes=false;show_success = true;"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          {{ $t('profile.modalPasswordBackup.title') }}
        </h5>
      </template>
      
      <div class="row backup_codes">
        <div class="col-12 mb-16">
          {{ $t('profile.modalPasswordBackup.copyBackup') }}
        </div>
        <div class="col-6">
          <p
            v-for="item in getfive"
            :key="item"
            class="mb-6"
          >
            {{ item }}
          </p>
        </div>
        <div class="col-6">
          <p
            v-for="item in getten"
            :key="item"
            class="mb-6"
          >
            {{ item }}
          </p>
        </div>
      </div>

      <template v-slot:footer>
        <div class="">
          <button
            class="btn btn-outline-primary btn-sm mt-8"
            @click="show_codes=false; show_success = true;"
          >
            &lt; {{ $t('profile.buttons.back') }}
          </button>
        </div>
      </template>
    </Modal>

    <Modal
      v-model:show="show_success"
      class="modal-password"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          {{ $t('profile.modalPasswordTwoFactor.title') }}
        </h5>
      </template>

      <div class="!tw-text-center">
        <h1 class="!tw-text-center mt-32">
          <img
            :src="okImg"
            alt=""
          >
        </h1>
        <p class="mb-32">
          {{ $t('profile.modalPasswordTwoFactor.securityCode') }}
        </p>
      </div>

      <template v-slot:footer>
        <div class="!tw-text-center">
          <button
            class="btn btn-primary btn-md mt-8"
            @click="show_codes=false; show_success = false"
          >
            {{ $t('profile.modalPasswordTwoFactor.btn') }}
          </button>
        </div>
      </template>
    </Modal>

    <EnableSuccess ref="success" />
  </section>
</template>

<script>
import { Modal } from '@/components';
import TfaCodeInput from '@/components/ui/TfaCodeInput.vue';

import googleOtpImg from '@/assets/theme/icon/google-otp.svg';
import appleOtpImg from '@/assets/theme/icon/apple-otp.svg';
import androidOtpImg from '@/assets/theme/icon/android-otp.svg';
import okImg from '@/assets/theme/icon/ok.svg';
import EnableSuccess from './EnableSuccess.vue';

export default {

  components: {
    Modal,
    EnableSuccess,
    TfaCodeInput,
  },
  data() {
    return {
      data: {},
      is_open: false,
      show_codes: false,
      show_success: false,
      token: '',
      pwd: '',
      errors_: {},
    };
  },
  computed: {
    googleOtpImg: () => googleOtpImg,
    appleOtpImg: () => appleOtpImg,
    androidOtpImg: () => androidOtpImg,
    okImg: () => okImg,
    getten() {
      if (this.data.backup_codes) return this.data.backup_codes.slice(0, 5);
      return [];
    },
    getfive() {
      if (this.data.backup_codes) return this.data.backup_codes.slice(5, 10);
      return [];
    },
  },

  methods: {
    enable() {
      const options = {
        title: this.$t('profile.secondFactorEnableForm.mainTitle'),
        callback: (pwd, modal) => {
          this.pwd = pwd;
          this.getQrCode(pwd, modal);
        },
      };
      this.$confirm.open('password', options);
    },

    getQrCode(pwd, modal) {
      modal.isLoading = true;
      const req = this.$request.post('totp/qr-code', { password: pwd });
      req.then((res) => {
        modal.close();
        this.data = res.data.payload;
        this.is_open = true;
      });
      req.catch((err) => {
        modal.errMessage = err.response.data.errors.password[0].message;
      });
      req.finally(() => modal.isLoading = false);
      this.token = '';
    },

    check2FACode() {
      this.$store
        .dispatch('otpEnable', { token: this.token })
        .then(() => {
          this.show_codes = true;
          this.is_open = false;
        })
        .catch((err) => {
          this.errors_ = err.response.data.errors;
          this.is_open = true;
        });
    },
  },

};
</script>

<style lang="scss">
@import 'styles/enablesecondfactor';
</style>
